import { IconSquare } from '@monthio/design-system'
import { Car, OwnedHome } from '@monthio/icons'
import { LoadingSpinner } from '@monthio/react-components'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Slider } from '../../../modulesTemp/shared/slider'

const Container = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 1rem;
`

const P = styled.p`
	font-size: 2rem;

	@media screen and (max-width: 500px) {
		font-size: 1.2rem;
	}
`

const Item = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	justify-content: center;
	padding-bottom: 5rem;

	> svg {
		aspect-ratio: 1;
		height: 50;
	}
`

export const LoadingCarousel: React.FC<{ children?: never }> = () => {
	const { t } = useTranslation()

	const texts = [
		{
			text: t('asset-overview.loading-assets.message-home'),
			icon: (
				<IconSquare
					icon={OwnedHome}
					backgroundColor="#E7F3FE"
					color="#0A70C2"
				/>
			),
		},
		{
			text: t('asset-overview.loading-assets.message-vehicle'),
			icon: <IconSquare icon={Car} backgroundColor="#F7F7FD" color="#565CD4" />,
		},
		{
			text: t('asset-overview.loading-assets.message-almost-there'),
		},
	]

	const [currentKey, setCurrentKey] = useState(0)

	useEffect(() => {
		let timeout: ReturnType<typeof setTimeout>
		if (currentKey < texts.length) {
			timeout = setTimeout(() => setCurrentKey(currentKey + 1), 4000)
		}
		return () => {
			clearTimeout(timeout)
		}
	}, [currentKey, texts.length])

	return (
		<Container>
			<LoadingSpinner />
			<Slider
				durationMs={300}
				items={texts.map(({ text, icon }, key) => ({
					element: (
						<Item>
							{() => icon}
							<P>{text}</P>
						</Item>
					),
					key,
				}))}
				currentKey={currentKey}
			/>
		</Container>
	)
}
